<template>
  <div
    :class="[
      'input-container',
      `input-container--${inputType}`,
      `input-container--${size}`,
      {
        'input-container--disabled': disabled,
        'input-container--readonly': readonly,
        'input-container--success': validationState === 'success',
        'input-container--error': validationState === 'error',
      },
    ]"
  >
    <BasicIcon
      v-if="iconState === 'iconLeft' && iconName && inputType === 'form'"
      :name="iconName"
    />
    <slot></slot>
    <BasicAlert
      v-if="inputType === 'table' && alertLabel"
      :class="[`input-container--${inputType}--alert`]"
      @click="showAlert(alertLabel)"
      :alertLabel
      :alertType
      :alertMaxlength="50"
      wrap
      :has-label="false"
      :hasBg="false"
    />
    <BasicIcon
      v-if="deletable && !readonly && !disabled && hasValue && !showLockIcon"
      name="close"
      @click="modelValue = null"
    />
    <BasicIcon
      v-if="inputType === 'form' && iconState === 'iconRight' && iconName && !showLockIcon"
      :name="iconName"
      :class="[`input-container--${inputType}--alert`]"
    />
    <BasicTooltip
      v-if="showLockIcon"
      :label="props.readOnlyReason ?? 'Lecture seule'"
      position="top"
    >
      <BasicIcon
        name="lock"
        class="input-container__lock-icon input-container__lock-icon--interactive"
      />
    </BasicTooltip>
  </div>
</template>

<script setup lang="ts">
  import type {
    AlertInputProps,
    InputDateModel,
    InputDureeModel,
    InputNumberModel,
    InputProps,
    InputTelephoneModel,
  } from '@designSystem/components'
  import { useDialog } from '@/features/interface/dialog'
  import { computed } from 'vue'

  const props = withDefaults(defineProps<InputProps & AlertInputProps>(), {
    size: 'medium',
    iconName: undefined,
    iconState: 'iconRight',
    deletable: false,
    readonly: false,
    disabled: false,
    inputType: 'form',
    hasBg: true,
    wrap: false,
    hasLabel: true,
    alertMaxlength: undefined,
    readOnlyReason: undefined,
  })

  type InputModel = InputDateModel | InputDureeModel | InputTelephoneModel | InputNumberModel | InputDateModel

  const modelValue = defineModel<InputModel>()

  const hasValue = computed(() => {
    const val = modelValue.value
    if (val === null || val === undefined) return false
    if (typeof val === 'object') {
      return Object.values(val).some((v) => v !== null && v !== undefined)
    }
    return true
  })

  const showLockIcon = computed(() => {
    return props.readonly
  })

  const showAlert = (message: string) => {
    const dialog = useDialog()
    dialog.showDialog({
      message,
      type: 'Error',
      closable: true,
    })
  }
</script>

<style lang="less">
  @import './InputContainer.less';
</style>
